import { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import "./ProductsListComp.css";
import search from "../../../assests/search.svg";
import leftArrow from "../../../assests/leftArrow.svg";
import emotions7 from "../../../assests/emotions7.svg";
import mingcute_eye from "../../../assests/mingcute_eye.svg";
import loading from "../../../assests/loading.gif";

const ProductsListComp = (props) => {
  const { variantId } = useParams();
  const navigate = useNavigate();
  const [showAllBrands, setShowAllBrands] = useState(false);
  const [showAllProducts, setShowAllProducts] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [showEyeIcon, setShowEyeIcon] = useState(false);
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);
  const productsGridRef = useRef(null);

  const handleVariantDetails = (variantId) => {
    navigate(`/home/configuration/productsvariantdetails/${variantId}`);
  };

  const handleMouseEnter = () => setShowEyeIcon(true);
  const handleMouseLeave = () => setShowEyeIcon(false);

  // Safe MRP display function
  const displayMRP = (variantMrp) => {
    if (!variantMrp) return "N/A";
    if (variantMrp.minMrp === null || variantMrp.maxMrp === null) return "N/A";
    return variantMrp.minMrp === variantMrp.maxMrp 
      ? variantMrp.minMrp 
      : `${variantMrp.minMrp}-${variantMrp.maxMrp}`;
  };

  // Infinite scroll handler
 

  useEffect(() => {
    if (selectedOption) {
      const sortedList = [...props.filteredItemList].sort((a, b) => {
        if (selectedOption === "asc") return a.variantName.localeCompare(b.variantName);
        if (selectedOption === "desc") return b.variantName.localeCompare(a.variantName);
        return 0;
      });
      props.setFilteredItemList(sortedList);
    }
  }, [selectedOption]);

  const toggleBrands = () => setShowAllBrands(!showAllBrands);
  const toggleProducts = () => setShowAllProducts(!showAllProducts);
  const toggleMobileFilters = () => setMobileFiltersOpen(!mobileFiltersOpen);

  return (
    <div className="products-container">
      {props.checkboxLoading && (
        <div className="loading-overlay">
          <CircularProgress className="prooading-spinner" />
        </div>
      )}

      {/* Header Section */}
      <header className="products-header">
        <div className="header-left">
          <img 
            src={leftArrow} 
            alt="Back" 
            className="back-icon" 
            onClick={props.arrowBackClick} 
          />
          <h1>Product Search</h1>
        </div>
        
        <div className="search-sort-container">
          <div className="search-box">
            <input
              type="search"
              placeholder="Search by Brand, Product, or Variant"
              value={props.searchQuery}
              onChange={(e) => {
                props.handleSearchChange(e);
                props.setInitialSearch(false);
              }}
              onKeyPress={props.handleKeyPress}
            />
            <img 
              src={search} 
              alt="Search" 
              className="search-icon" 
              onClick={props.handleSearchClick} 
            />
          </div>

          {props.filteredItemList?.length > 0 && (
            <div className="sort-dropdown">
              <select
                value={props.selectedOption}
                onChange={props.handleSortChange}
              >
                <option value="">Sort by</option>
                <option value="asc">A to Z</option>
                <option value="desc">Z to A</option>
              </select>
            </div>
          )}
        </div>

        <button className="mobile-filter-btn" onClick={toggleMobileFilters}>
          {mobileFiltersOpen ? <CloseIcon /> : <MenuIcon />}
          <span>Filters</span>
        </button>
      </header>

      {/* Main Content Area */}
      <main className="products-main">
        {/* Filters Sidebar - Desktop */}
        <aside className={`filters-sidebar ${mobileFiltersOpen ? 'mobile-open' : ''}`}>
          {props.filteredItemList?.length > 0 && (
            <>
              <div className="filter-section">
                <h3>BRANDS</h3>
                <div className="filter-items">
                  {(showAllBrands ? props.brandList : props.brandList?.slice(0, 4)).map((brand, index) => (
                    <div key={index} className="filter-item">
                      <label>
                        <input
                          type="checkbox"
                          checked={props.selectedBrands?.includes(brand.brandName)}
                          onChange={() => props.handleBrandCheckboxChange(brand.brandName)}
                        />
                        <span>{brand.brandName}</span>
                      </label>
                    </div>
                  ))}
                </div>
                <button className="view-toggle" onClick={toggleBrands}>
                  {showAllBrands ? "View Less" : "View More"}
                </button>
              </div>

              <div className="filter-section">
                <h3>PRODUCTS</h3>
                <div className="filter-items">
                  {(showAllProducts ? props.productList : props.productList?.slice(0, 4)).map((product, index) => (
                    <div key={index} className="filter-item">
                      <label>
                        <input
                          type="checkbox"
                          checked={props.selectedProducts?.includes(product.productName)}
                          onChange={() => props.handleProductCheckboxChange(product.productName)}
                        />
                        <span>{product.productName}</span>
                      </label>
                    </div>
                  ))}
                </div>
                <button className="view-toggle" onClick={toggleProducts}>
                  {showAllProducts ? "View Less" : "View More"}
                </button>
              </div>
            </>
          )}
        </aside>

        {/* Products Grid */}
        <div 
          className="products-grid-container" 
          
          ref={props.tableContainerRef}
        >
          {props.initialSearch ? (
            <div className="empty-state">
              <p>Please search for a product.</p>
            </div>
          ) : props.loadingProduct ? (
            <div className="loading-state">
              <img src={loading} alt="Loading" />
              <h3>Loading...</h3>
            </div>
          ) : props.hasFilteredItems ? (
            <div className="products-grid">
              {props.filteredItemList.map((item) => (
                <div
                  key={item.variantId}
                  className="product-card"
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                  onClick={() => handleVariantDetails(item.variantId)}
                >
                  {item.variantImages?.[0] && (
                    <img
                      src={`https://s3.ap-south-1.amazonaws.com/daalchini/dcprod/${item.variantImages[0].imageId}`}
                      alt={item.variantName}
                      className="product-image"
                    />
                  )}
                  <img
                    src={mingcute_eye}
                    alt="View details"
                    className={`product-eye-icon ${showEyeIcon ? "visible" : ""}`}
                  />
                  <div className="product-info">
                    <h3>{item.brandName}</h3>
                    <p>{item.productName}</p>
                    <p>{item.variantName}</p>
                    <div className="price-info">
                      <span>
                        M.R.P: <CurrencyRupeeIcon className="rupee-icon" />
                        {displayMRP(item.variantMrp)}
                      </span>
                      <span className="product-id">ID - {item.variantId}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="empty-state">
              <img src={emotions7} alt="No products found" />
              <p>No Product Found</p>
            </div>
          )}

          {props.isLoadingMore && !props.noMoreResults && (
            <div className="loading-more">
              <CircularProgress size={24} />
              <h3>Loading more products...</h3>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default ProductsListComp;